<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作产品路径</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.code" placeholder="请输入编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="account_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="account_option"
                    :default_option="queryParams['account_option']"
                    @onDropChange="onDropChange"
                    ref="account_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="business_unit_rid"
                    model_name="请选择业务单元"
                    :model_value_default="queryParams['business_unit_rid']"
                    request_uri="dropdownBusinessUnits"
                    select_value="rid"
                    @onDropChange="onDropChange"
                    ref="business_unit_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="status"
                    model_name="状态"
                    select_value="value"
                    request_uri="dropdownCommonStatus"
                    :model_value_default="queryParams['status']"
                    @onDropChange="onDropChange"
                    ref="status_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="person_rid"
                    model_name="请选择人员"
                    :model_value_default="queryParams['person_rid']"
                    request_uri="dropdownPerson"
                    :request_params="{ with_empty: true }"
                    @onDropChange="onDropChange"
                    ref="person_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="performance_basis_code"
                    model_name="请选择绩效类型"
                    :model_value_default="queryParams['performance_basis_code']"
                    request_uri="dropdownPerformanceBasis"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="performance_basis_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="province_sign"
                    model_name="请选择省份"
                    select_value="value"
                    :model_value_default="queryParams['province_sign']"
                    request_uri="dropdownProvinceSign"
                    :request_params="{ with_empty: true }"
                    @onDropChange="onDropChange"
                    ref="province_sign_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="lock_sign"
                    model_name="请选择锁定标记"
                    select_value="value"
                    :model_value_default="queryParams['lock_sign']"
                    request_uri="dropdownPpaLockSign"
                    @onDropChange="onDropChange"
                    ref="lock_sign_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn" :loading="btnLoading"
                    >新增</el-button
                >

                <el-button size="small" plain @click="flushBusinessDate" :loading="btnLoading">刷新业务日期</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="partner_product_account" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="partner_product_account"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['account', 'code', 'partner', 'product'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'partnerProductAccountComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner_product_account'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'account' && row.account_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.account_rid
                    }
                });
            } else if (prop == 'product' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'partner' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'code' && row.rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('partner_product_account_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('partner_product_account_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner_product_account', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_product_account;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'partnerProductAccountLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();

            this.$refs.partner_rid_ref.reset();
            this.$refs.product_rid_ref.reset();
            this.$refs.account_rid_ref.reset();
            this.$refs.business_unit_rid_ref.reset();
            this.$refs.status_ref.reset();
            this.$refs.person_rid_ref.reset();
            this.$refs.performance_basis_code_ref.reset();
            this.$refs.province_sign_ref.reset();
            this.$refs.lock_sign_ref.reset();

            this.getList();
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'partnerProductAccountEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        flushBusinessDate() {
            this.$confirm('您确定要刷新吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['partnerProductAccountFlushBusinessDate']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功！',
                                    type: 'success'
                                });
                            }
                            this.reload();
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'partnerProductAccountDelete', row.name);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>